import { Field } from 'formik';
import { LegalEntityPicker } from './legal-entity-picker';
import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from '../filters/base-url-params-filter';
import { CompanyTypeFilter } from '@sr/dto';

export const LegalEntityParamFilter = ({ queryParamName, label, size = 'medium', companyId,  companyTypeFilter }: BaseUrlParamsFilterProps & { companyId?: string | number, companyTypeFilter?: CompanyTypeFilter }) => {
  return (
    <BaseUrlParamsFilter queryParamName={queryParamName}>
      <Field fullWidth name={queryParamName} label={label} clearable={true} size={size} component={LegalEntityPicker} companyIdFilter={companyId} companyTypeFilter={companyTypeFilter}/>
    </BaseUrlParamsFilter>
  );
};
